// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import question css modules
import sentimentAnswerStyles from '../sentimentAnswerModuleStyles.css';

function SentimentAnswerListItem({ sentimentAnswer }) {
  return (
    <li>
      <Link to={`/sentiment-answers/${sentimentAnswer._id}`}> {sentimentAnswer.name}</Link>
    </li>
  )
}

SentimentAnswerListItem.propTypes = {
  question: PropTypes.object.isRequired
}

export default SentimentAnswerListItem;



// WEBPACK FOOTER //
// modules/sentimentAnswer/components/SentimentAnswerListItem.js.jsx